import StatsPreviewCard from "./StatsPreviewCard";

function App() {
  return (
    <StatsPreviewCard />
  )
}

export default App;
